class VideoUrlDetector {
  private static YOUTUBE_LIST_MATCHER_LONG = /youtube\.com.+v=([\w-]+)&list=([\w-]+)(?:&index=(\d+))?/;
  private static YOUTUBE_LIST_MATCHER_SHORT = /youtu\.be\/([^&?]+).+[&?]list=([\w-]+)(?:&index=(\d+))?/;
  private static YOUTUBE_MATCHER_LONG = /youtube\.com.+v=([^&?]+)(?!.*\blist=\b)/;
  private static YOUTUBE_MATCHER_SHORT = /youtu\.be\/([^&?]+)(?!.*\blist=\b)/;
  private static VIMEO_MATCHER_SHORT = /vimeo\.com\/([^&?]+)/;

  static extractIdFromUrl(url: string, pattern: RegExp) {
    const match = url.match(pattern);
    return match ? match[1] : undefined;
  }

  static getYoutubeListData(url: string):
    | {
        videoId: string;
        listId: string;
        index: number;
      }
    | undefined {
    const match = url.match(this.YOUTUBE_LIST_MATCHER_LONG) || url.match(this.YOUTUBE_LIST_MATCHER_SHORT);
    if (match) {
      const videoIndex = match[3] ? Number(match[3]) - 1 : 0;
      return { videoId: match[1], listId: match[2], index: videoIndex };
    }
    return undefined;
  }

  static getYoutubeId(url: string) {
    return (
      this.extractIdFromUrl(url, this.YOUTUBE_MATCHER_LONG) || this.extractIdFromUrl(url, this.YOUTUBE_MATCHER_SHORT)
    );
  }

  static getVimeoId(url: string) {
    return this.extractIdFromUrl(url, this.VIMEO_MATCHER_SHORT);
  }

  static isYouTubeList(url: string): boolean {
    return Boolean(this.getYoutubeListData(url));
  }

  static isYouTube(url: string): boolean {
    return Boolean(this.getYoutubeId(url));
  }

  static isVimeo(url: string) {
    return Boolean(this.getVimeoId(url));
  }

  static isSupported(url: string) {
    return this.isYouTube(url) || this.isYouTubeList(url) || this.isVimeo(url);
  }
}

export { VideoUrlDetector };
